import type { Meta, StoryFn } from '@storybook/react';

import { LiveLog } from '@pega/cosmos-react-core';
import type { LiveLogProps } from '@pega/cosmos-react-core';

import { SubComponent } from './LiveLog.mocks';

export default {
  title: 'Core/LiveLog',
  component: LiveLog,
  parameters: {
    layout: 'centered'
  }
} as Meta;

export const LiveLogDemo: StoryFn<LiveLogProps> = () => {
  return <SubComponent />;
};
